import { Button, DialogContentText, Grid, Input, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { styled } from '@mui/material/styles';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import upload from './../../../../../assets/icons/cloud-computing.png'
import CloseIcon from '@mui/icons-material/Close';
import checked from './../../../../../assets/icons/checked.png'
import { uploadFiles } from '../../../../../fileUploader/FileUploader';
import pending from './../../../../../assets/icons/pending.png'
import './DocumentUpload.css'
import { ToastContainer, toast } from 'react-toastify';

function DocumentsUpload(props) {

  const [open, setOpen] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('sm');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };



  const handleFullWidthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFullWidth(event.target.checked);
  };

  const [tableData, setTableData] = useState([
    {
      Id: '12233445',
      KycCompanyDetailsId: '',
      Name: 'Company information',
      Description: 'One of: Certificate of incorporation/Certificate of legal existence/Certificate of good standing',
      File: [],
      Comment: 'comment',
    },
    {
      Id: '12233445',
      KycCompanyDetailsId: '',
      Name: 'Company Bank Statement',
      Description: 'Bank statement of the corporate bank account (dated within the last 3 months)',
      File: [],
      Comment: 'comment',
    },
    {
      Id: '12233445',
      KycCompanyDetailsId: '',
      Name: 'Directors Auth/Sign. Proof of identity',
      Description: 'One of: Passport/National Id card/Driving license',
      File: [],
      Comment: 'comment',
    },
    {
      Id: '12233445',
      KycCompanyDetailsId: '',
      Name: 'Directors Auth/Sign. Proof of Residency',
      Description: 'One of: Utility bill/Bank statement/Bank reference letter/Govt issued document (dated within last 3 months)',
      File: [],
      Comment: 'comment',
    },
    {
      Id: '12233445',
      KycCompanyDetailsId: '',
      Name: 'UBO Proof of Identity',
      Description: 'One of: Passport/National Id',
      File: [],
      Comment: 'comment',
    },
    {
      Id: '12233445',
      KycCompanyDetailsId: '',
      Name: 'UBO Proof of Residency',
      Description: 'One of: Utility bill/Bank statement/Bank reference letter/Govt issued document (dated within last 3 months)',
      File: [],
      Comment: 'comment',
    },
    {
      Id: '12233445',
      KycCompanyDetailsId: '',
      Name: 'Company insurance information',
      Description: 'Insurance document (dated within last 3 months)',
      File: [],
      Comment: 'comment',
    },
  ]);

  const [obj, setObj] = useState({
    Id: '12233445',
    KycCompanyDetailsId: '',
    Name: '',
    Description: '',
    File: [],
    Comment: 'comment'
  })
  const [state, setState] = useState<ImageUploadState>({
    selectedImages: [],
  })

  const [filesData, setFilesData] = useState([]);
  // const handleImageUpload = (event) => {
  //   const files = event.target.files
  //   console.log(files);
  //   if (files) {

  //     const imagesArray: string[] = []
  //     const remainingSlots = 5 - state.selectedImages.length
  //     const filesToUpload = Array.from(files).slice(0, remainingSlots)
  //     console.log(filesToUpload);
  //     setFilesData(filesToUpload);
  //     tableData[0].File.push(filesToUpload);
  //     props.parentData(tableData)
  //     event.target.value = '';
  //     for (let i = 0; i < filesToUpload.length; i++) {
  //       const file = filesToUpload[i]
  //       const reader = new FileReader()
  //       reader.onloadend = () => {
  //         imagesArray.push(reader.result as string)
  //         if (imagesArray.length === filesToUpload.length) {
  //           const updatedImages = [...state.selectedImages, ...imagesArray]
  //           setState({ selectedImages: updatedImages })
  //         }
  //       }
  //       reader.readAsDataURL(file)
  //     }
  //   }
  // }

  const [companyBankStatementstate, setCompanyBankStatementstate] = useState<ImageUploadState>({
    selectedImages: [],
  })

  // const [filesData, setFilesData] = useState([]);
  // const handleCompanyBankStatementstateUpload = (event) => {
  //   const files = event.target.files

  //   if (files) {

  //     const imagesArray: string[] = []
  //     const remainingSlots = 5 - companyBankStatementstate.selectedImages.length
  //     const filesToUpload = Array.from(files).slice(0, remainingSlots)
  //     console.log(filesToUpload);
  //     setFilesData(filesToUpload);
  //     tableData[1].File.push(filesToUpload);
  //     props.parentData(tableData)
  //     event.target.value = '';
  //     for (let i = 0; i < filesToUpload.length; i++) {
  //       const file = filesToUpload[i]
  //       const reader = new FileReader()
  //       reader.onloadend = () => {
  //         imagesArray.push(reader.result as string)
  //         if (imagesArray.length === filesToUpload.length) {
  //           const updatedImages = [...companyBankStatementstate.selectedImages, ...imagesArray]
  //           setCompanyBankStatementstate({ selectedImages: updatedImages })
  //         }
  //       }
  //       reader.readAsDataURL(file)
  //     }
  //   }
  // }

  const isFileSizeValid = (file, maxSizeInBytes) => {
    if (file && file.size <= maxSizeInBytes) {
      return file;
    }

  };
  const [CompanyInfoFiles, setCompanyInfoFiles] = useState([]);
  const handleCompanyInfoFileChange = (event) => {
    var valid = true;
    const files = event.target.files[0]

    const maxSizeInBytes = 50 * 1024 * 1024;

    if (isFileSizeValid(files, maxSizeInBytes)) {
      tableData[0].File.push(files)
      props.parentData(tableData)
      props.parentData(tableData)
      setCompanyInfoFiles([...CompanyInfoFiles, ...event.target.files]);
    } else {

      valid = false;
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  }


  const [CompanyBankStatementFiles, setCompanyBankStatementFiles] = useState([]);
  const handleCompanyBankStatementFileChange = (event) => {

    var valid = true;
    const files = event.target.files[0];
    const maxSizeInBytes = 50 * 1024 * 1024;

    if (isFileSizeValid(files, maxSizeInBytes)) {
      tableData[1].File.push(files);
      props.parentData(tableData);
      setCompanyBankStatementFiles([...CompanyBankStatementFiles, ...event.target.files]);
    } else {

      // alert("File size should be less than or equal to 50 MB.");
      valid = false;
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

  };

  const [DirectorIdentityFiles, setDirectorIdentityFiles] = useState([]);
  const handleDirectorIdentityFileChange = (event) => {
    var valid = true;
    const files = event.target.files[0];

    const maxSizeInBytes = 50 * 1024 * 1024;

    if (isFileSizeValid(files, maxSizeInBytes)) {
      tableData[2].File.push(files)
      props.parentData(tableData)
      setDirectorIdentityFiles([...DirectorIdentityFiles, ...event.target.files]);
    } else {

      valid = false;
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const [DirectorResidenseFiles, setDirectorResidenseFiles] = useState([]);
  const handleDirectorResidenseFileChange = (event) => {
    var valid = true;
    const files = event.target.files[0];

    const maxSizeInBytes = 50 * 1024 * 1024;

    if (isFileSizeValid(files, maxSizeInBytes)) {
      tableData[3].File.push(files)
      props.parentData(tableData)

      setDirectorResidenseFiles([...DirectorResidenseFiles, ...event.target.files]);
    } else {

      valid = false;
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const [UBOIdentityFiles, setUBOIdentityFiles] = useState([]);
  const handleUBOIdentityFileChange = (event) => {
    var valid = true;
    const files = event.target.files[0];

    const maxSizeInBytes = 50 * 1024 * 1024;

    if (isFileSizeValid(files, maxSizeInBytes)) {
      tableData[4].File.push(files)
      props.parentData(tableData)

      setUBOIdentityFiles([...UBOIdentityFiles, ...event.target.files]);
    } else {

      valid = false;
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };


  const [UBOResidenseFiles, setUBOResidenseFiles] = useState([]);
  const handleUBOResidenseFileChange = (event) => {
    var valid = true;
    const files = event.target.files[0];

    const maxSizeInBytes = 50 * 1024 * 1024;

    if (isFileSizeValid(files, maxSizeInBytes)) {
      tableData[5].File.push(files)
      props.parentData(tableData)

      setUBOResidenseFiles([...UBOResidenseFiles, ...event.target.files]);
    } else {

      valid = false;
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const [InsuranceFiles, setInsuranceFiles] = useState([]);
  const handleInsuranceFileChange = (event) => {
    var valid = true;
    const files = event.target.files[0];

    const maxSizeInBytes = 50 * 1024 * 1024;

    if (isFileSizeValid(files, maxSizeInBytes)) {
      tableData[6].File.push(files)
      props.parentData(tableData)

      setInsuranceFiles([...InsuranceFiles, ...event.target.files]);
    } else {

      valid = false;
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const handleNameChange = (event) => {
    setObj((prevObj) => ({ ...prevObj, Name: event.target.value }));
  }
  const handleDescriptionChange = (event) => {
    setObj((prevObj) => ({ ...prevObj, Description: event.target.value }));
  }
  const handleCommentChange = (event) => {
    setObj((prevObj) => ({ ...prevObj, Comment: event.target.value }));
  }

  const [documentName, setDocumentName] = useState()
  const [documentDescription, setDocumentDescription] = useState()
  const [documentComment, setDocumentComment] = useState()

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [preview, setPreview] = useState('');

  const handleFileChange = (event) => {
    const files = event.target.files;

    setSelectedFiles([...selectedFiles, ...files]);
  };
  useEffect(() => {

    setObj((prevObj) => ({ ...prevObj, File: selectedFiles }));

  }, [selectedFiles]);
  //file upload end
  console.log(obj)


  const [parent, setParent] = useState(true)
  const onAdd = () => {
    var valid = true;
    if (obj.Name === '' || obj.Description === '' || obj.File.length === 0) {
      valid = false;
      toast.error("Name, Description & File must be inserted", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else {



      const newObj = {
        Id: '12233445',
        KycCompanyDetailsId: obj.KycCompanyDetailsId,
        Name: obj.Name,
        Description: obj.Description,
        File: obj.File,
        Comment: obj.Comment,
      };
      setTableData((prevData) => [...prevData, newObj]);
      props.parentData(tableData)
      setParent(!parent)
      setSelectedFiles([])
      setOpen(false)

    }
  }
  useEffect(() => {
    props.parentData(tableData)
  }, [parent])
  console.log(tableData)

  const UploadFile = () => {
    console.log(filesData);

    uploadFiles(tableData[1].File);
  }
  console.log(tableData[0].File)

  return (
    <>
      <ToastContainer />
      <div className='p-3 '>


        <Dialog

          open={open}
          onClose={handleClose}

        >
          <div className='dialogColor'>
            <Grid className='d-flex justify-content-between'>
              <DialogTitle>
                Add document

              </DialogTitle>
              <DialogActions>
                <Button onClick={handleClose}><CloseIcon /></Button>
              </DialogActions>
            </Grid>
            <DialogContent>
              <Grid xs={12} className='nameTextarea'>
                <TextField fullWidth id="outlined-basic" label="Name" variant="filled"
                  onChange={handleNameChange} />
              </Grid>
              <Grid xs={12} className='pt-3 descriptionText'>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Description"
                  multiline
                  rows={4}
                  // defaultValue="Default Value"
                  variant="filled"
                  onChange={handleDescriptionChange}
                />
              </Grid>
              <Grid xs={12}>
                <div className='pt-3'>
                  <Input
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    id="file-uploader"
                  />

                  <label htmlFor="file-uploader" className='dotted-border'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>

                  {selectedFiles.length > 0 && (
                    <div>

                      <ul >
                        {selectedFiles.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}


                </div>
              </Grid>
              <Grid xs={12} className='pt-3 descriptionText'>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Type comment (optional)"
                  multiline
                  rows={4}
                  // defaultValue="Default Value"
                  variant="filled"
                  onChange={handleCommentChange}
                />
              </Grid>
              <Grid xs={12} className='pt-3'>
                <div className='add-cancel d-flex  justify-content-between'>
                  <button className='buttonWidth'>Cancel</button>
                  <button className='buttonWidth buttonWidthAdd' onClick={onAdd}>Add</button>
                </div>
              </Grid>
            </DialogContent>
          </div>
        </Dialog>
        <Grid xs={12}>
          <div className="kyc-form-page__table-wrapper">
          <table className='documentUpload mt-4' style={{ width: '100%' }}>
            <tr>
              <th>Name</th>
              <th>Status</th>
              <th>Documents</th>

            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <h6> Company information*</h6>
                <p className='tableDescription'>
                  One of: Certificate of incortporation/Certificate of legal existance/Certificate of good standing
                </p>
              </td>
              <td style={{ width: '30%' }}>
                {tableData[0].File.length != 0 ?
                  <div className='d-flex'>

                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                  </div> :
                  <div className='d-flex'>

                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                  </div>
                }

              </td>
              <td>
                <div className='pt-3'>


                  <Input
                    type="file"
                    onChange={handleCompanyInfoFileChange}
                    style={{ display: 'none' }}
                    id="companyInfo-file-uploader"
                  />

                  {tableData[0].File.length > 0 && (
                    <div>

                      <ul className='dotted-border-forfiles d-flex flex-column'>
                        {tableData[0].File.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}
                  <label htmlFor="companyInfo-file-uploader" className='uploadText'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>



                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <h6> Company Bank Statement*</h6>
                <p className='tableDescription'>
                  Bank statement of the corporate ban account (dated within the last 3 months)
                </p>
              </td>
              <td style={{ width: '30%' }}>
                {tableData[1].File.length != 0 ?
                  <div className='d-flex'>

                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                  </div> :
                  <div className='d-flex'>

                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                  </div>
                }

              </td>
              <td>
                <div className='pt-3'>
                  <Input
                    type="file"
                    onChange={handleCompanyBankStatementFileChange}
                    style={{ display: 'none' }}
                    id="CompanyBankStatement-file-uploader"
                  />

                  <label htmlFor="CompanyBankStatement-file-uploader" className='uploadText'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>

                  {tableData[1].File.length > 0 && (
                    <div>

                      <ul className='dotted-border-forfiles d-flex flex-column'>
                        {tableData[1].File.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}


                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <h6> Directopr's Auth/Sign. Proof of iedentity*</h6>
                <p className='tableDescription'>
                  One of: Passport/National Id card/Driving license
                </p>
              </td>
              <td style={{ width: '30%' }}>
                {tableData[2].File.length != 0 ?
                  <div className='d-flex'>

                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                  </div> :
                  <div className='d-flex'>

                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                  </div>
                }

              </td>
              <td>
                <div className='pt-3'>
                  <Input
                    type="file"
                    onChange={handleDirectorIdentityFileChange}
                    style={{ display: 'none' }}
                    id="DuirectorIdentity-file-uploader"
                  />

                  <label htmlFor="DuirectorIdentity-file-uploader" className='uploadText'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>

                  {tableData[2].File.length > 0 && (
                    <div>

                      <ul className='dotted-border-forfiles d-flex flex-column'>
                        {tableData[2].File.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}


                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <h6> Directopr's Auth/Sign. Proof of Resindence*</h6>
                <p className='tableDescription'>
                  One of: Utility bill/Bank statement/Bank reference letter/Govt issued document (dated within last 3 months)
                </p>
              </td>
              <td style={{ width: '30%' }}>
                {tableData[3].File.length != 0 ?
                  <div className='d-flex'>

                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                  </div> :
                  <div className='d-flex'>

                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                  </div>
                }
              </td>
              <td>
                <div className='pt-3'>
                  <Input
                    type="file"
                    onChange={handleDirectorResidenseFileChange}
                    style={{ display: 'none' }}
                    id="DirectorResidense-file-uploader"
                  />

                  <label htmlFor="DirectorResidense-file-uploader" className='uploadText'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>

                  {tableData[3].File.length > 0 && (
                    <div>

                      <ul className='dotted-border-forfiles d-flex flex-column'>
                        {tableData[3].File.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}


                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <h6> UBO Proof of Identity*</h6>
                <p className='tableDescription'>
                  One of: Passport/National Id
                </p>
              </td>
              <td style={{ width: '30%' }}>
                {tableData[4].File.length != 0 ?
                  <div className='d-flex'>

                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                  </div> :
                  <div className='d-flex'>

                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                  </div>
                }

              </td>
              <td>
                <div className='pt-3'>
                  <Input
                    type="file"
                    onChange={handleUBOIdentityFileChange}
                    style={{ display: 'none' }}
                    id="UBOIdentity-file-uploader"
                  />

                  <label htmlFor="UBOIdentity-file-uploader" className='uploadText'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>

                  {tableData[4].File.length > 0 && (
                    <div>

                      <ul className='dotted-border-forfiles d-flex flex-column'>
                        {tableData[4].File.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}


                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <h6> UBO Proof of Resindence*</h6>
                <p className='tableDescription'>
                  One of: Utility bill/Bank statement/Bank reference letter/Govt issued document (dated within last 3 months)
                </p>
              </td>
              <td style={{ width: '30%' }}>
                {tableData[5].File.length != 0 ?
                  <div className='d-flex'>

                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                  </div> :
                  <div className='d-flex'>

                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                  </div>
                }

              </td>
              <td>
                <div className='pt-3'>
                  <Input
                    type="file"
                    onChange={handleUBOResidenseFileChange}
                    style={{ display: 'none' }}
                    id="UBOResidense-file-uploader"
                  />

                  <label htmlFor="UBOResidense-file-uploader" className='uploadText'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>

                  {tableData[5].File.length > 0 && (
                    <div>

                      <ul className='dotted-border-forfiles d-flex flex-column'>
                        {tableData[5].File.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}


                </div>
              </td>
            </tr>

            <tr>
              <td style={{ width: '30%' }}>
                <h6>Company insurance information*</h6>
                <p className='tableDescription'>
                  Insurance document (dated within last 3 months)
                </p>
              </td>
              <td style={{ width: '30%' }}>
                {tableData[6].File.length != 0 ?
                  <div className='d-flex'>

                    <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>

                  </div> :
                  <div className='d-flex'>

                    <img src={pending} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                    <p style={{ color: '#cc9840', marginLeft: '2px' }}> Not uploaded</p>

                  </div>
                }

              </td>
              <td>
                <div className='pt-3'>
                  <Input
                    type="file"
                    onChange={handleInsuranceFileChange}
                    style={{ display: 'none' }}
                    id="Insurance-file-uploader"
                  />

                  <label htmlFor="Insurance-file-uploader" className='uploadText'>

                    Upload
                    <img src={upload} alt='upload' style={{ width: '1.5rem', height: '1.5rem', marginLeft: '2px' }} />
                  </label>

                  {tableData[6].File.length > 0 && (
                    <div>

                      <ul className='dotted-border-forfiles d-flex flex-column'>
                        {tableData[6].File.map((file, index) => (

                          <li key={index}>{file.name}</li>

                        ))}
                      </ul>
                    </div>
                  )}


                </div>
              </td>
            </tr>
            {tableData.length > 7 && tableData.slice(7).map((data, index) => {
              return (
                <tr key={index}>
                  <td style={{ width: '30%' }}>
                    <h6> {data.Name}</h6>
                    <p className='tableDescription'>{data.Description}</p>
                  </td>
                  <td style={{ width: '30%' }}>
                    <div className='d-flex'>
                      {data.File.length != 0 ? (
                        <>
                          <img src={checked} alt='' style={{ width: '1.5rem', height: '1.5rem' }} />
                          <p style={{ color: 'green', marginLeft: '2px' }}> Done</p>
                        </>) :
                        <p>Required</p>
                      }

                    </div>

                  </td>
                  <td>
                    <ul className='dotted-border-forfiles d-flex flex-column'>
                      {data.File.map((dt, index) => (
                        <li key={index}>{dt.name}</li>
                      ))}
                    </ul>
                  </td>
                </tr>
              )
            })}



          </table>
          </div>
        </Grid>
        <div className='mt-3 d-flex  align-items-center' style={{ gap: "10px" }}>
          <Button variant="contained" className='UploadButton' onClick={handleClickOpen}>+ Add document</Button>
          <span className='additionalText'>Please note that adding additional document can significantly decreases reviewing time.</span>
        </div>
      </div>
    </>
  )
}

export default DocumentsUpload